<template>
	<u-drawer
		size="380px"
		:title="`${ currentpageName }-展示字段筛选`"
		:visible="drawer"
		@close="handleClose">
		<div class="screenMidden paddinglr30" style="padding-bottom:50px;">
			<el-checkbox-group class="screenMiddenShowul" v-model="selectbtns">
				<el-checkbox class="checkboxshow" v-for="(item,index) in btns" :label="item.prop" :key="item.lable" border>{{item.lable}}</el-checkbox>
				<button class="defaultbtn" style="visibility: hidden;width: 193px;"></button>
			</el-checkbox-group>
		</div>
		<template v-slot:footer>
			<button  class="defaultbtn" @click="reset">恢复默认</button>
			<button class="defaultbtn defaultbtnactive" @click="getparent('reach')">确 定</button>
		</template>
	</u-drawer>
</template>

<script>
	import DataScreen from "@/assets/DataScreen.js"
	export default {
		props:["pageName", "show"],
		data() {
		  return {
			checkAll: false,
			btns: [],
			isIndeterminate: true,
			selectbtns:[],
			currentpageName:"",
			drawer: false
		  };
		},
		methods:{
			handleClose() {
				this.getparent()
			},
			getparent(data){
				//传值到父组件隐藏本组件 
				if(data == "reach") {
					this.saveSelectBts(this.selectbtns)
				}
				this.$parent.screenmask("Off","right2");
			},
			reset() {
				//重置默认选中按钮
				this.selectbtns = DataScreen.screenShow[this.pageName].defaults;
			},	
			handleCheckedCitiesChange(value) {
				this.selectbtns = value;
			},
			getScreen(){
				//alert(this.pageName)
				//以及pagenema获取相应的展示字段
				this.btns = DataScreen.screenShow[this.pageName].bts;
			},
			saveSelectBts(value){
				//传值到commonTable.vue;
				//console.log(value);
				eventBus.$emit("screenShowDataChange",value);
				localStorage.setItem("screenShowDataChange",value.join(","));
			},
			initbts(){
				//初始化
				//console.log(localStorage.getItem("screenShowDataChange"))
				if(localStorage.getItem("screenShowDataChange")){
					this.selectbtns =  localStorage.getItem("screenShowDataChange").split(',');
				} else {
					this.selectbtns = DataScreen.screenShow[this.pageName].defaults ;
				}
			}
		},
		watch: {
			show(val) {
				if(val) {
					this.getScreen();
					this.initbts();
					this.currentpageName = this.$route.matched[this.$route.matched.length-1].meta.title;
				}

				this.drawer = val
			}
		}
	}
</script>

<style scoped="scoped">
	.screenbordershow{
		width: 380px;
		background: #FFFFFF;
		border-radius: 5px;
		position: absolute;
		right: 335px;
		top: 110px;
		overflow-y: scroll;
        height: calc(100% - 127px);
	}
	
	.screenMiddenShowul{
		padding-top:30px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		flex-flow: row wrap; 
	}
	
	.checkboxshow{
		height: 56px;
		margin: 0;
		margin-bottom: 20px;
	}
	
	.el-checkbox.is-bordered.is-checked{
		border: none !important;
		float: left;
        width: 47%;
		margin-left: 0 !important;
	}
	
	.el-checkbox.is-bordered{
		border: none !important;
		float: left;
        width: 47%;
		margin-left: 0 !important;
	}
	
	.el-checkbox__input.is-focus .el-checkbox__inner{
		border-color: #DCDFE6 !important;
	}
	
	.el-checkbox{
		margin-right: 0 !important;
	}
	.screenBottom{
		width: 380px;
		position: fixed;
		bottom: 1.8%;
		padding: 0;
		background: #FFFFFF;
		z-index: 999999;
	}
</style>
